module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deviations":"Deviations","mustSaveTrip":"The trip must be saved before a deviation can be connected to it.","noDeviations":"There are no registered deviations.","addDeviation":"Add new deviation"},"no":{"deviations":"Avvik","mustSaveTrip":"Turen må lagres før avvik kan tilknyttes.","noDeviations":"Det er ingen registrerte avvik.","addDeviation":"Legg til nytt avvik"}}')
  delete Component.options._Ctor
}
